<div class="parent" [ngClass]="{ 'is-enabled': isActive }">
    @if (isActive) {
        <div class="mocks-block" [ngClass]="!showMore && 'has-minimal-height'">
            <div class="box">
                <div class="rows">
                    <div class="row is-flex is-justified-end">
                        <button
                            (click)="toggleReveal()"
                            checkoutCy="dev-configurator-toggle"
                            class="button is-secondary"
                        >
                            <span class="icon">
                                <i [ngClass]="showMore ? 'tri-arrow-down' : 'tri-arrow-up'"></i>
                            </span>
                        </button>
                        <button class="button is-primary is-circled" checkoutCy="close_mock_btn" (click)="toggleMock()">
                            <span class="icon">
                                <i class="tri-times" aria-hidden="true"></i>
                            </span>
                        </button>
                    </div>
                </div>
                <div class="tabs has-text-centered is-marginless" data-tabs-context>
                    <div class="tab-list">
                        @for (tab of tabs | keyvalue; track tab; let i = $index) {
                            <button
                                [attr.aria-selected]="tab.value.label === currentTab.label ? 'true' : 'false'"
                                data-tab-navigation
                                class="tab {{ tab.value.label === currentTab.label ? 'is-active' : '' }}"
                                (click)="changeTab(tab.key)"
                                role="tab"
                            >
                                {{ tab.value.title }}
                            </button>
                        }
                    </div>
                </div>
                <div
                    checkoutCy="dev-configurator-mocks-url"
                    [ngClass]="{ 'is-hidden': currentTab.title !== tabs.STEP_MOCK_CONFIGURATOR.title }"
                >
                    <checkout-mockups-configurator></checkout-mockups-configurator>
                </div>
                @if (currentTab.title === tabs.PRODUCTS.title) {
                    <div>
                        <checkout-mockups-products></checkout-mockups-products>
                    </div>
                }
                @if (currentTab.title === tabs.MODAL.title) {
                    <div>
                        <checkout-mockups-modal></checkout-mockups-modal>
                    </div>
                }
                @if (currentTab.title === tabs.USER.title) {
                    <div class="is-flex">
                        <div class="buttons is-flex is-multiline">
                            <button id="btn-login" (click)="login()" class="button is-primary is-small">
                                Connexion
                            </button>
                            <button (click)="logout()" class="button is-primary is-small">Déconnexion</button>
                            <button (click)="changeLoading()" class="button is-primary is-small">Skeleton</button>
                            <button (click)="setGalliumPrices()" class="button is-primary is-small">
                                Ajouter mock gallium prices dans storage
                            </button>
                            <button (click)="setFtth3Clics()" class="button is-primary is-small">
                                Activer le parcours FTTH 3Clics
                            </button>
                            <button (click)="mockInsurance()" class="button is-primary is-small">
                                Ajouter option assurance "incompatible"
                            </button>
                            <button (click)="proWall()" class="button is-primary is-small">
                                Activer le panier "Mur des pros"
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
    }
    @if (!isActive) {
        <button
            checkoutCy="dev-configurator-open"
            (click)="toggleMock()"
            class="icon is-circled is-large is-pulled-right has-text-white mock-toggle has-background-main has-back"
        >
            <i class="tri-hand-tools"></i>
        </button>
    }
</div>
